import React from 'react';
import PropTypes from 'prop-types';
import { SelectField } from 'material-ui';
import { MenuItem } from 'material-ui/IconMenu';

const ChoiceSelectField = ({ choices, floatingLabelText, id, name, onChange, onBlur, value }) => {

    const handleChange = (event, index, value) => {
        event.persist();

        event.target.name = event.target.id || name;
        event.target.value = value;

        onChange(event, index, value);
    };

    return (
        <SelectField
            id={ id || name }
            floatingLabelText={ floatingLabelText }
            onChange={ handleChange }
            onBlur={ onBlur }
            value={ value }
        >
            {
                choices.map((choice) => {
                    return (
                        <MenuItem
                            key={ choice.value }
                            primaryText={ choice.label }
                            value={ choice.value }
                        />
                    );
                })
            }
        </SelectField>
    );
};

ChoiceSelectField.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    })).isRequired,
    floatingLabelText: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

export default ChoiceSelectField;



// WEBPACK FOOTER //
// ./src/components/input/SelectField/ChoiceSelectField.js